module.exports = __webpack_public_path__ + "static/photo5-2de952826523ce32622cf15e811405ca.jpg";